import Vue from 'vue';
import axios from 'axios';
import Vueaxios from 'vue-axios';
import env from './enviroment';
import {mapState,mapActions} from "vuex";
//url de prueba local
//const baseURL = 'http://localhost:3000';
const baseURL = env.baseURL;
axios.defaults.baseURL = baseURL;
axios.defaults.headers.common["Content-Type"] = "application/json";
//axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
var token = localStorage.getItem("tokenAuth");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// Add a 401 response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
    localStorage.removeItem("user");
    localStorage.removeItem("tokenAuth");
    localStorage.removeItem("logged");
    axios.defaults.headers.common['Authorization'] = 'Bearer '+ "";
    /*Notify.SuccessToast("¡Adios!");*/
    if(window.location.pathname !== "/admin/login" && window.location.pathname !== "/admin/Login"){
      location.reload()
     }
    
      return Promise.reject(error);
  } else {
      return Promise.reject(error);
  }
});

Vue.use(Vueaxios, axios);